
import { defineComponent, PropType, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  props: {
    /**
     * 双列布局
     */
    diallel: {
      type: Boolean,
      default: false,
    },

    /**
     * 双列布局
     */
    handle: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const route = useRoute();
    const title: any = ref("-");
    onMounted(() => {
      title.value = route.meta.title;
    });
    return {
      title,
    };
  },
});
